"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.identifyUser = identifyUser;
exports.initializeErrorReporting = initializeErrorReporting;
exports.reportError = reportError;
var Sentry = _interopRequireWildcard(require("@sentry/react"));
var _tracing = require("@sentry/tracing");
var _logrocket = _interopRequireDefault(require("logrocket"));
var _logrocketReact = _interopRequireDefault(require("logrocket-react"));
var _constants = require("../../constants");
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var deploymentStage = _constants.STAGE_DEVELOPMENT;
function canReportErrors() {
  if (process.env.REACT_APP_REPORT_ERRORS_DEBUG === 'true') {
    // eslint-disable-next-line no-console
    console.log("error-reporting: deploymentStage: ".concat(deploymentStage));
  }
  var reportErrors = process.env.REACT_APP_REPORT_ERRORS === 'true';
  if (isValidStage()) {
    reportErrors = process.env.REACT_APP_REPORT_ERRORS === undefined || process.env.REACT_APP_REPORT_ERRORS !== 'false';
  }
  return reportErrors;
}
function isValidStage() {
  return !(0, _index.isFedRAMP)() && (deploymentStage === _constants.STAGE_BETA || deploymentStage === _constants.STAGE_PRODUCTION);
}
function initializeErrorReporting(appId, dsn, appPrefix) {
  var _requestSanitizer2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  var _responseSanitizer2 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
  var sampleRate = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1.0;
  var debug = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : process.env.REACT_APP_REPORT_ERRORS_DEBUG === 'true';
  var stage = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : _constants.STAGE_DEVELOPMENT;
  deploymentStage = stage;
  if (canReportErrors()) {
    if (debug) {
      // eslint-disable-next-line no-console
      console.log("error-reporting: Sentry sample rate: ".concat(sampleRate));
    }
    Sentry.init({
      dsn: dsn,
      debug: debug,
      integrations: [].concat(_toConsumableArray(Sentry.defaultIntegrations), [new _tracing.Integrations.BrowserTracing({
        // Can also use reactRouterV3Instrumentation or reactRouterV4Instrumentation
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
      })]),
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: sampleRate,
      release: "".concat(appPrefix, "@").concat(process.env.REACT_APP_BUILD_VERSION),
      environment: stage
    });
    _logrocket.default.init(appId, {
      release: process.env.REACT_APP_BUILD_VERSION,
      network: {
        requestSanitizer: function requestSanitizer(request) {
          return _requestSanitizer(request, _requestSanitizer2);
        },
        responseSanitizer: function responseSanitizer(response) {
          return _responseSanitizer(response, _responseSanitizer2);
        }
      }
    });
    (0, _logrocketReact.default)(_logrocket.default);
    _logrocket.default.getSessionURL(function (sessionURL) {
      Sentry.configureScope(function (scope) {
        scope.setExtra('sessionURL', sessionURL);
      });
    });
  }
}
function _requestSanitizer(request, requestSanitizer) {
  var USER_TOKEN = 'x-wasabi-user-token'; // Rack/NOC user token
  var AUTH_TOKEN = 'X-Wasabi-Authorization'; // IAM based auth token
  var REDACTED_VALUE = '** REDACTED **';

  // sanitize the auth header...
  if (request.headers[AUTH_TOKEN]) {
    request.headers[AUTH_TOKEN] = REDACTED_VALUE;
  } else if (request.headers[USER_TOKEN]) {
    request.headers[USER_TOKEN] = REDACTED_VALUE;
  }

  // sanitize the password while creating an account...
  if (request.body) {
    var requestBody = JSON.parse(request.body);
    if (requestBody.Password) {
      // if the request contains a Password, obscure if from view to/from LogRocket
      requestBody.Password = REDACTED_VALUE;

      // re-construct the request body...
      request.body = JSON.stringify(requestBody);
    }
    if (requestBody.password) {
      // if the request contains a password, obscure if from view to/from LogRocket
      requestBody.password = REDACTED_VALUE;

      // re-construct the request body...
      request.body = JSON.stringify(requestBody);
    }
  }
  return requestSanitizer ? requestSanitizer(request) : request;
}
function _responseSanitizer(response, responseSanitizer) {
  return responseSanitizer ? responseSanitizer(response) : response;
}
function reportError(error) {
  if (canReportErrors()) {
    _logrocket.default.captureException(error, {
      tags: {
        stage: process.env.NODE_ENV
      }
    });
    Sentry.captureException(error);
  }
}
function identifyUser(userProfile) {
  if (canReportErrors()) {
    _logrocket.default.identify(userProfile.Name, {
      name: "".concat(userProfile.FullName)
    });
    Sentry.setUser({
      username: userProfile.Name
    });
  }
}